class SimulatorLastMessagesReportController {
    constructor($browser, $window, $location, ngProgressFactory, moment, toastr, UserDetails, UtpSimServiceApi, ReportServiceApi, ReportUtilityServiceApi, SettingsExService, ReportUtils) {
        this.state = {
            showSelectors: true,
            canExport: true,
            userDetails: null,
            reportRequest: {
                SimId: 0,
                Type: ''
            },
            DateFormats: null,
            selectedSim: null,
            selectedType: '',
            hideNav: true,
            showReport: false
        };
        this.data = {
            sims: [],
            messageTypes: [],
            lastSimulatorMessages: [],
            filteredLastSimulatorMessages: []
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.timeCellRenderer = (params) => {
            // Strong type is giving improper ts to js conversion, also see http://momentjs.com/guides/#/warnings/js-date/
            // Timestamp already converted in init
            // On GUI, datetime is displayed as local not UTC, in sync with CSV export
            let lastSimMessage = params.data;
            let time = [
                '<span>',
                lastSimMessage.Timestamp,
                '</span>'
            ].join('');
            return time;
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
        };
        this.selectSim = (sim) => {
            if (angular.isUndefined(sim)) {
                sim = { Id: 0, Name: 'No Simulators' };
            }
            this.state.selectedSim = sim;
            this.gridOptions.api.onFilterChanged();
            this.state.canExport = false;
            this.getGrid();
        };
        this.simulators = (simulators) => {
            if (simulators == null || simulators === undefined) {
                return [{ Id: 0, Name: 'No Simulators' }];
            }
            let sims = _.map(simulators, (item) => {
                return {
                    Id: item.Id,
                    Name: item.SimName
                };
            });
            let sorted = _.sortBy(sims, ['Name']);
            return sorted;
        };
        this.types = (messageTypes) => {
            let types = _.map(messageTypes, (item) => {
                return {
                    Id: item.Id,
                    Name: item.MessageType
                };
            });
            let sorted = _.sortBy(types, ['Name']);
            return sorted;
        };
        this.filterLastSimulatorMessages = (lastSimulatorMessages, sim, type) => {
            let messages = lastSimulatorMessages;
            if (sim > 0) {
                messages = _.filter(messages, (item) => {
                    return item.SimId === sim;
                });
            }
            if (type !== '') {
                messages = _.filter(messages, (item) => {
                    return item.MessageType.substring(0, type.length) === type;
                });
            }
            return messages;
        };
        this.$onInit = () => {
            this.init();
        };
        this.getGrid = () => {
            // Put the data in the view model so that we can inspect it
            let messages = this.filterLastSimulatorMessages(this.data.lastSimulatorMessages, this.state.selectedSim.Id, this.state.selectedType);
            this.data.filteredLastSimulatorMessages = messages;
            this.gridOptions.api.setRowData(messages);
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.clearType = () => {
            this.state.selectedType = '';
            this.getGrid();
        };
        this.limitType = () => {
            this.state.selectedType = this.state.selectedType.replace(/\s/g, '');
            this.getGrid();
        };
        this.exportCsv = () => {
            this.traceProgress.start();
            let title = [
                this.state.selectedSim.Name,
                ' ',
                '- ' + this.simulatorLastMessagesReport.Description + '.csv'
            ].join('');
            let reportName = this.ReportUtilityServiceApi.addDateToTitle(title);
            let date = this.moment(new Date()).format(this.state.DateFormats.DateFormat);
            let time = this.moment(new Date()).format(this.state.DateFormats.TimeFormat);
            let params = {
                allColumns: false,
                fileName: reportName
            };
            if (this.state.selectedSim.Id !== 0) {
                let published = [' created on ' + date, ' at ', time].join('');
                let customHeader = [
                    'Simulator Last Messages Report for sim: ',
                    this.state.selectedSim.Name,
                    published,
                    '\n\n'
                ].join('');
                params['customHeader'] = customHeader;
            }
            this.gridOptions.api.exportDataAsCsv(params);
            this.traceProgress.complete();
        };
        this.init = () => {
            this.columnDefs = [
                {
                    headerName: 'Id',
                    field: 'Id',
                    width: 65,
                    minWidth: 65,
                    hide: true
                },
                {
                    headerName: 'SimId',
                    field: 'SimId',
                    width: 65,
                    minWidth: 65,
                    filter: 'number',
                    hide: true
                },
                {
                    headerName: 'Simulator',
                    field: 'SimName',
                    width: 350,
                    minWidth: 120,
                    sort: 'asc'
                },
                {
                    headerName: 'Message Type',
                    field: 'MessageType',
                    width: 250,
                    minWidth: 150,
                },
                {
                    headerName: 'Timestamp',
                    field: 'Timestamp',
                    width: 250,
                    minWidth: 155,
                    cellRenderer: this.timeCellRenderer,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Trace',
                    field: 'TraceId',
                    width: 60,
                    minWidth: 60,
                    filter: 'number',
                    hide: true
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.rowCount = 0;
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.simulatorLastMessagesReport = {
                Id: 0,
                Name: '',
                Description: 'Simulator Last Message Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.state.hideNav = _.startsWith(this.location.path(), '/Reports');
            // Hide report until we know wether we are using narrow or wide
            this.state.showReport = false;
            this.traceProgress.start();
            this.SettingsExService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.showReport = true;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
            });
            this.UserDetails.get().then((response) => {
                // ConnectedUser
                this.state.userDetails = response; // setup our user details
                // If elevated then attempt to get all sims. If not get only sims for logged in user
                const requestedUserId = this.state.userDetails.IsAdmin || this.state.userDetails.IsSupport ? -1 : this.state.userDetails.Id;
                this.UtpSimServiceApi.getAllSimulators(requestedUserId, false, false, false, false).then((simResponse) => {
                    let sims = simResponse.data;
                    /* Get all Sims */
                    this.data.sims = this.simulators(sims.activeSimulatorsList);
                    this.ReportServiceApi.getSimulatorMessageTypes().then((typesResponse) => {
                        let messageTypes = typesResponse.data;
                        /* Get all Message Types */
                        this.data.messageTypes = this.types(messageTypes);
                        // We get all of the data and then filter it on the client side
                        this.ReportServiceApi.getSimulatorLastMessages(this.state.reportRequest).then((messagesResponse) => {
                            let lastSimMessages = messagesResponse.data;
                            this.data.lastSimulatorMessages = this.ReportUtilityServiceApi.adjustToLocalTime(messagesResponse.data, this.state.userDetails.TimezoneOffset);
                            this.traceProgress.complete();
                        });
                    });
                });
            }, () => {
                this.traceProgress.complete();
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.ReportServiceApi.getReportByName('SimulatorLastMessagesReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.simulatorLastMessagesReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
            this.traceProgress.complete();
            return;
        };
        this.browser = $browser;
        this.window = $window;
        this.location = $location;
        this.ngProgressFactory = ngProgressFactory;
        this.moment = moment;
        this.toastr = toastr;
        this.UserDetails = UserDetails;
        this.UtpSimServiceApi = UtpSimServiceApi;
        this.ReportServiceApi = ReportServiceApi;
        this.ReportUtilityServiceApi = ReportUtilityServiceApi;
        this.SettingsExService = SettingsExService;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('simulatorLastMessagesReport', {
    bindings: {},
    templateUrl: 'Scripts/App/Partials/Reports/simulator-last-messages-report.tpl.html',
    controllerAs: 'vm',
    controller: SimulatorLastMessagesReportController
});
